import React from 'react';
import styled from 'styled-components';

import { DeviceQueries } from 'Common/src/components/styled';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  return <Layout className="main-layout">
    <Container>
      <Outlet/>
    </Container>
  </Layout>;
};

const Layout = styled.div`
  display: flex;
  height: 100vh;
  height: 100svh;
  min-height: fit-content;
`;

const Container = styled.div`
  color: var(--shine-text-color);
  display: flex;
  flex-direction: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 100%;
  width: 100%;
`;

export const Page = styled.div`
  padding: 25px;
  flex-grow: 1;
`;

export const PageFooter = styled.div`
  text-align: center;
  padding: 25px;
`;

export const FooterButtonContainer = styled.div`
  flex-grow: 1;
  padding: 0 25px;
  max-width: 400px;
  display: flex;
  gap: 20px;
`;

export default MainLayout;

